// src/contexts/network-context.tsx
import React, { createContext, useContext } from 'react';
import { useNetworkStatus } from '../hooks/use-network-status';

type NetworkContextValue = {
  connected: boolean;
  connectionType: string;
  checkNow: () => Promise<void>;
};

const NetworkContext = createContext<NetworkContextValue | null>(null);

export const NetworkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const status = useNetworkStatus();

  return (
    <NetworkContext.Provider value={status}>
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetwork = (): NetworkContextValue => {
  const ctx = useContext(NetworkContext);
  if (!ctx) throw new Error('useNetwork must be used within NetworkProvider');
  return ctx;
};
